export default __webpack_public_path__ + "static/media/wait.78c99277.svg";